import { Folder } from 'src/app/models/server/folder';
import { View } from 'src/app/models/server/view';

export class DialogMergeData {
    /**
     *
     * @param view : Instance de la vue.
     * @param sourceFolders Liste des dossiers à fusionner.
     * @param targetFolder Dossier cible de la fusion.
     */
    public constructor(
        public view: View,
        public sourceFolders: Folder[],
        public targetFolder: Folder
    ) {}
}
